import React, {Component} from "react";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../configuration";
import {toast} from "react-toastify";
import {css} from "glamor";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import InitialQuotationState from "../../Site/QuotationForm/InitialQuotationState";
import FormFieldValidationError from "../../Common/FormFieldValidationError/FormFieldValidationError";
import NumberFormatter from "../../Common/NumberFormatter/NumberFormatter";
import {Modal} from "react-bootstrap";
import StatusChange from "./StatusChange";
import EditProductionCode from "./EditProductionCode";
import './ProductionTable.css'

class ProductionRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            productBarcode: "",
            productionResult: [],
            productionId: -1,
            productBarcodeError: '',
            orderDate: '',
            barcodeFromDB: ""
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.saveProductBarcode = this.saveProductBarcode.bind(this);
        this.getProductionBarcodeBYOrderId = this.getProductionBarcodeBYOrderId.bind(this);
        this.getPdfData = this.getPdfData.bind(this);
        this.validateSagawaCode = this.validateSagawaCode.bind(this);
    }

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            productBarcodeError: ''
        });
    };

  /*  componentDidMount() {
        this.getProductionBarcodeBYOrderId();
        // this.getOrderDate();

    }
*/
    validateSagawaCode = () => {
        // console.log("validate sagawa code");
        let sagawaCode = this.state.productBarcode;
        let valid = 1;
        if (sagawaCode === '' || sagawaCode === undefined || sagawaCode === null) {
            valid = 0;
        }else if(sagawaCode.length!==14) {
            valid = 2
        }
        return valid;
    };

    saveProductBarcode() {

        let productBarcodeError = "";
        let validationPassed = true;
        let valid = this.validateSagawaCode();
        if (valid === 0) {
            validationPassed = false;
            productBarcodeError = "app.validation.production-barcode.invalid-barcode";

        }
        if (valid === 2) {
            validationPassed = false;
            productBarcodeError = "app.validation.production-barcode.invalid-barcode-length";

        }
        // console.log("bar",this.state.productBarcode);
        // console.log("OOOOOOOO",this.props.order);
        if (valid === 1) {
            let postData = {
                barcode: this.props.order.barcode,
                itemId: this.props.order.id,
                productBarcode: this.state.productBarcode
            };
            // console.log("post", postData);
            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access-Control-Allow-Origin': '*'
                }
            };

            axios.post(RESOURCE_BASE_URL + 'api/orders/productBarcode',
                {
                    barcode: this.props.order.barcode,
                    itemId: this.props.order.orderItemId,
                    orderId: this.props.order.orderId,
                    productBarcode: this.state.productBarcode
                }, axiosConfig)
                .then((res) => {
                    /*this.setState({
                        // show : true
                    });*/
                    // console.log(res.data);
                    // console.log("barcode saved successfully");
                    // this.getProductionBarcodeBYOrderId();
                    this.props.getAllProduction();
                    toast("佐川のバーコード番号が正常に保存されました。", {
                        className: css({
                            background: "#96d146 !important",
                            padding: "30px",
                            color: "black !important",
                            width : '400px'
                        })
                    });
                })
                .catch((err) => {
                    console.log("AXIOS ERROR: ", err);

                    toast("佐川バーコード番号の保存に失敗しました。", {
                        className: css({
                            background: "#db4f64 !important",
                            padding: "30px",
                            color: "black !important",
                            width : '400px'

                        })
                    });
                });
        } else {
            this.setState({productBarcodeError});
        }
    }

    getProductionBarcodeBYOrderId = () => {
        axios.get(RESOURCE_BASE_URL + 'api/production/order/' + this.props.order.orderItemId + '/' + this.props.order.orderId)
            .then((res) => {
                this.setState({
                    productionResult: res.data,
                    productBarcode: res.data.productBarcode,
                    barcodeFromDB: res.data.productBarcode,
                    productionId: res.data.itemId
                });
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    getOrderDate = () => {
        axios.get(RESOURCE_BASE_URL + 'api/items/date/' + this.props.order.id)
            .then((res) => {
                this.setState({
                    orderDate: res.data
                });
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    getPdfData = () => {
        // console.log("prod-orderid",this.props.order.orderId )
        // console.log("prod-barcode",this.state.productBarcode )
        // console.log("prod-lang", InitialQuotationState.lang )
        // console.log("prod-barc2", this.props.order.productBarcode )
        let dummyCode = "0000";

        let orderResourceUrl = RESOURCE_BASE_URL + 'api/barcode/batch/' + this.props.order.orderId + '/' + this.props.order.orderItemId + '/' + InitialQuotationState.lang + '/' + this.props.order.productBarcode;
        // console.log("locale",InitialQuotationState.lang);
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
            }
        };
        let postData = {

            barcode: this.props.order.productBarcode

        };
        if (this.props.order.productBarcode !== null) {

            axios.post(orderResourceUrl, postData, axiosConfig)
                .then((res) => {
                    // console.log("res123", res.data);
                    // for (let i=0;i<res.data.length;i++){
                    fetch("data:application/pdf;base64," + res.data.pdfFile)
                        .then((resp) => {
                            return resp.blob()
                        })

                        .then((blob) => {
                            // console.log("BLOB====> ", blob);

                            const fileURL = URL.createObjectURL(blob);
                            window.open(fileURL);
                            // window.location.href = fileURL;

                        });
                    // }

                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                });
        }else {
            toast("最初に有効なコードを入力してください。", {
                className: css({
                    background: "#db4f64 !important",
                    padding: "30px",
                    color: "black !important"
                })
            });
        }

    };

    render() {
        let pcbParams = this.props.order.orderPlacingRequest.pcbParam;
        return (
            <tr>
                <td>{this.props.order.batchNumber}</td>
                <td><text id="generate-text-id">{this.props.order.generatedBarcode}</text></td>
                <td>
                    {this.props.order.orderPlacingRequest.shippingAddress.postalCode}
                    {this.props.order.orderPlacingRequest.shippingAddress.province}
                    {this.props.order.orderPlacingRequest.shippingAddress.city}
                    {this.props.order.orderPlacingRequest.shippingAddress.streetAddress}
                    {this.props.order.orderPlacingRequest.shippingAddress.addressLine2}
                </td>
                <td>
                    {/*¥<NumberFormatter num = {this.props.order.unitPrice}/>*/}
                    {this.props.order.pricingRequest.orderType === 1 &&
                    <text>{pcbParams.qty}</text>
                    }
                    {this.props.order.pricingRequest.orderType === 2 &&
                    <text>{this.props.order.pricingRequest.pcbParam.qty}</text>
                    }
                    {this.props.order.pricingRequest.orderType === 3 &&
                    <text>{this.props.order.orderPlacingRequest.smtStencilParam.stencilQty}</text>
                    }
                </td>
                <td>
                    {this.props.order.productBarcode !== null  ?
                        <div>
                            <input type="text"
                                   id="barcode-input"
                                   className="form-control input-sm barcode-input"
                                   name="productBarcode"
                                   value={this.props.order.productBarcode}
                                   onChange={this.onInputChange}
                                   disabled={true}
                                   maxLength="14"
                            /> </div>:
                        <div> <input type="text"
                                     id="barcode-input"
                                     className="form-control input-sm barcode-input"
                                     value={this.state.productBarcode}
                                     name="productBarcode"
                                     onChange={this.onInputChange}
                                     maxLength="14"


                        />
                            <FormFieldValidationError errors={this.state.productBarcodeError}/>
                        </div>
                    }
                    {/* <input type="text"
                               id="barcode-input"
                               className="form-control input-sm"
                               value={this.state.productBarcode}
                               name="productBarcode"
                               onChange={this.onInputChange}/>*/}
                </td>
                <td>
                    {this.props.order.productBarcode !== null ?
                        <button className="btn btn-success btn-xs" disabled={true}>
                            保存
                        </button> :
                        <button className="btn btn-success btn-xs" onClick={this.saveProductBarcode}>
                            保存
                        </button>
                    }
                    &nbsp;
                    <button className="btn btn-warning btn-xs set-font-size-12">
                        <Link to={{
                            pathname: "items/view/" + this.props.order.orderId,
                            state: {
                                items: this.props.order
                            }
                        }}>
                            {/*<Link to={"item/view/" + this.props.order.id}>*/}
                            詳細
                        </Link>
                    </button>
                    &nbsp;
                    <button className="btn btn-primary btn-xs" onClick={this.getPdfData}>印刷</button>
                    {this.props.order.productBarcode !== null &&
                    <StatusChange orderId={this.props.order.orderId}
                                  batchNumber={this.props.order.batchNumber}
                                  getAllProduction = {this.props.getAllProduction}
                    />
                    }
                    {/*&nbsp;*/}
                    {this.props.order.productBarcode !== null &&
                    <EditProductionCode orderId={this.props.order.orderId}
                                        orderItemId={this.props.order.orderItemId}
                                        batchNumber={this.props.order.batchNumber}
                                        getAllProduction = {this.props.getAllProduction}
                                        barcode={this.props.order.barcode}
                                        generatedBarcode={this.props.order.generatedBarcode}

                    />
                    }
                </td>
            </tr>

        )
    }
}

export default ProductionRow;



// WEBPACK FOOTER //
// ./src/components/Admin/ProductionCompletionList/ProductionRow.js